"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITY_FIELD_AND_TYPE = void 0;
exports.ENTITY_FIELD_AND_TYPE = {
    field: "'device_ip'",
    type: "'_ip'",
};
